import styled from "styled-components";
import Colors from "../../themes/Colors";
import Fonts from "../../themes/Fonts";
import { fadeIn } from "../Common/CommonStyles";

export const TableContainer = styled.div.attrs(props => ({
  'data-testid': props.testid
}))`
  width: ${(props) => props.width || ""};
  max-width: ${(props) => props.maxWidth || ""};
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: ${(props) => props.font || Fonts.familyVerlag};
  position: relative;
  overflow: visible;
  @media screen and (max-width: 844px) {
    animation: ${fadeIn} 0.5s ease-in;
  }
`;

export const TableWrapper = styled.div`
  width: ${(props) => props.width || "auto"};
  max-width: ${(props) => props.maxWidth || "1000px"};
  font-family: ${(props) => props.font || Fonts.familyVerlag};
  position: relative;
  overflow: visible;
  @media screen and (max-width: 844px) {
    width: auto;
    max-width: 400px;
    animation: ${fadeIn} 0.5s ease-in;
  }
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  font-family: ${(props) => props.font || Fonts.familyVerlag};
  @media screen and (max-width: 844px) {
    animation: ${fadeIn} 0.5s ease-in;
  }
`;

export const TableHeader = styled.thead`
  background-color: ${(props) => props?.headerColor || Colors.primaryPrimera};
  color: #fff;
  font-family: ${(props) => props.font || Fonts.familyVerlag};
  color: ${(props) => props?.textColor || Colors.primaryPrimera};
  text-align: center;
`;

export const TableHeaderCell = styled.th`
  padding: 12px;
  font-family: ${(props) => props.font || Fonts.familyVerlag};
  background-color: ${(props) => props?.cellColor || Colors.primaryPrimera};
  text-align: center;
  width: ${(props) => props.columnWidth || "auto"};
  max-width: ${(props) => props.columnWidth || "auto"};
`;

export const TableBody = styled.tbody``;

export const TableRow = styled.tr`
  &:nth-child(even) {
    background-color: #f2f2f2;
  }
`;

export const TableCell = styled.td`
  padding: 12px;
  font-family: ${(props) => props.font || Fonts.familyVerlag};
  text-align: center;
  position: relative;
  overflow: ${(props) => (props.hasEllipsis ? "visible" : "visible")};
  text-overflow: ${(props) => (props.hasEllipsis ? "ellipsis" : "clip")};
  white-space: ${(props) => (props.hasEllipsis ? "nowrap" : "normal")};
  width: ${(props) => props.columnWidth || "auto"};
  max-width: ${(props) => props.columnWidth || "auto"};
`;

export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 16px;
  font-family: ${(props) => props.font || Fonts.familyVerlag};
`;

export const PaginationButton = styled.button`
  padding: 8px 16px;
  border: 1px solid #ccc;
  font-family: ${(props) => props.font || Fonts.familyVerlag};
  background-color: ${({ active, paginationColor }) =>
    active ? paginationColor || Colors.primaryHumano : "transparent"};
  color: ${({ active }) => (active ? "#fff" : "#0e6eb8")};
  cursor: ${({ active }) => (active ? "default" : "pointer")};
  margin: 0 4px;

  &:hover {
    background-color: ${({ active }) => (active ? "#0e6eb8" : "#f2f2f2")};
    color: ${({ active }) => (active ? "#fff" : "#0e6eb8")};
  }
`;

export const CellSeparator = styled.th`
  width: ${(props) => props.width || ""};
  height: ${(props) => props.height || "1px"};
  background-color: ${(props) => props.backgroundColor || Colors.transparent};
`;